import addInputMask from "./add-inputmask";
import onInputComplete from "./on-input-complete";
import resetField from "./reset-field";

export function initMarknadsinformation() {
    
    const mask = "99999999-9999";
    
    document.querySelectorAll(".gfield--type-marknadsinformation").forEach(function( field ) {
        
        field.querySelectorAll(".gform-marknadsinformation-input").forEach(function(input) {      
            addInputMask(input, mask);
            onInputComplete(input, field, mask);
            
            input.addEventListener('input', function() {
                onInputComplete(input, field, mask);
            });
            
        });
        
    });
    
}
